import './PersonPage.css'
import { useEffect, useState } from "react";
import axios from "axios";
import { Avatar, Badge, Center, Flex, Loader, Stack } from "@mantine/core";


export default function PersonPage({person}) {



    return (
        <>

            {person && <section className="PersonPage-content-wrapper">
                <PersonHeader {...person} />
                <hr className='PersonPage--separation-line' />
                <PersonInfo {...person.about} />
            </section>}
        </>
    )
}


const PersonHeader = ({ name, lastname, profilePicture, type, nationality }) => {


    const renderType = (_type) => {
        if (!_type) return 'USUARIO'
        const value = _type.toLowerCase()

        if (value === 'teacher') return 'PROFESOR'
        if (value === 'staff') return 'STAFF'
        return "USUARIO"
    }

    return <section className="PersonHeader-main-container">
        <figure className='PersonHeader-main-container--image-container'>
            <Avatar
                size={100}
                src={profilePicture || null}
                alt={`${name} ${lastname}`}
            />
        </figure>
        <Stack gap={0}>
            <h1 className="PersonHeader--name">
                {`${name} ${lastname}`}

            </h1>
            <Flex gap={8}>
                <Badge>
                    {renderType(type)}
                </Badge>
                {nationality && <Badge variant='outline' color='var(--color-text-primary)'>
                    {nationality}
                </Badge>}
            </Flex>
        </Stack>
    </section>
}
const PersonInfo = ({ personalItems, description }) => {
    // Agrupar por "item"
    const groupedItems = personalItems?.reduce((acc, current) => {
        const key = current.item;
        if (!acc[key]) acc[key] = [];
        acc[key].push(current.value);
        return acc;
    }, {});

    return (
        <section className='PersonInfo-main-container'>
            {description && (
                <div>
                    <h4 className='PersonInfo--title'>
                        <strong>Sobre mí</strong>
                    </h4>
                    <p className='PersonInfo--description-text'>{description}</p>
                </div>
            )}

            {groupedItems && Object.keys(groupedItems).length > 0 && (
                <Stack>
                    {Object.entries(groupedItems).map(([label, values]) => {
                        const IS_OTHER_LABEL = label.toLowerCase() === 'otro'
                        return <>
                            {IS_OTHER_LABEL && <hr style={{ opacity: .2 }} />}
                            <div key={label}>

                                {!IS_OTHER_LABEL && <h4 className='PersonInfo--title'>
                                    <strong>{label}</strong>
                                </h4>}
                                {values.map((value, index) => (
                                    <p key={index} className='PersonInfo--description-text'>
                                        {value}
                                    </p>
                                ))}
                            </div>
                        </>
                    })}
                </Stack>
            )}
        </section>
    );
};
